import { render } from "./uiButton.vue?vue&type=template&id=fb7079e2&scoped=true&ts=true"
import script from "./uiButton.vue?vue&type=script&lang=ts"
export * from "./uiButton.vue?vue&type=script&lang=ts"

import "./uiButton.vue?vue&type=style&index=0&id=fb7079e2&lang=css&scoped=true"

import exportComponent from "C:\\AttiTec\\DogToDo\\dev\\todo-list-vuejs-pwa-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb7079e2"]])

export default __exports__